/* eslint-disable no-underscore-dangle */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from 'firebase/firestore';
import { getIdToken, onAuthStateChanged } from 'firebase/auth';
import { COLLECTIONS, affiliateStatus, BackendServer } from '../configs/Constants';
import { auth, db } from '../configs/Firebase';

const updateInventoryDocument = (documentId, jsonData) => {
  // Reference to the document
  const documentRef = doc(db, 'rezgoInventoryData', documentId);

  // Update the document with the provided JSON data
  const res = updateDoc(documentRef, jsonData)
    .then(() => ({
      status: 200,
      msg: 'Inventory updated successfully',
    }))
    .catch((error) => ({
      status: 401,
      msg: `Something went wrong. ${error}`,
    }));
  return res;
};
export const UpdateInventory = async () => {
  try {
    const url = `${BackendServer.baseURL}/filters`;
    const responseInventory = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await responseInventory.json();
    const jsonDatadata = {
      jsonData: await data,
    };
    const msg = updateInventoryDocument('jsonData', jsonDatadata);

    return msg;
  } catch {
    return {
      status: 500,
      msg: 'Something went wrong!',
    };
  }
};

const mailTriggerOnApproval = async (refEmail, firstNamee, lastNamee, promoCode) => {
  await new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        unsubscribe(); // Unsubscribe to prevent multiple calls
        resolve(user);
      } else {
        // Keep waiting for authentication state to be restored
      }
    });
  });
  const user = auth.currentUser;
  const token = await getIdToken(user, true);
  const url = `${BackendServer.baseURL}/mail_on_approving`;
  const data = {
    ref_email: refEmail,
    firstName: firstNamee,
    lastName: lastNamee,
    promocode: promoCode,
  };
  const responseMail = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(data),
  });
  return responseMail;
};

const ProcessPaymentUsingBackend = async (ids) => {
  await new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        unsubscribe(); // Unsubscribe to prevent multiple calls
        resolve(user);
      } else {
        // Keep waiting for authentication state to be restored
      }
    });
  });
  const user = auth.currentUser;
  const token = await getIdToken(user, true);
  const url = `${BackendServer.baseURL}/processpayment`;
  const responsePayment = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(ids),
  });

  const resjsonData = responsePayment.json();
  return resjsonData;
};

export const getAffiliatesWithStatus = async (status) => {
  const rows = [];
  const q = query(
    collection(db, COLLECTIONS.AFFILIATES),
    where('affiliateStatus', '==', Number(status))
  );
  const querySnapshot = await getDocs(q);

  for (let i = 0; i < querySnapshot.docs.length; i++) {
    const d = querySnapshot.docs[i];

    const tempData = d.data();

    const commissionPercentages = [];

    if (tempData.promocodes) {
      for (let index = 0; index < tempData.promocodes.length; index++) {
        const promocode = tempData.promocodes[index];

        // Get commission
        const pDocRef = doc(db, COLLECTIONS.CREATED_PROMOCODES, promocode);
        const pDocSnap = await getDoc(pDocRef);
        if (pDocSnap.exists) {
          commissionPercentages.push(pDocSnap.data()?.commission_percentage || 'N/A');
        }
      }
    }
    rows.push({
      id: d.id,
      ...tempData,
      createdAt: new Date(d?._document?.createTime?.timestamp?.seconds * 1000).toDateString() || '',
      status: Number(tempData?.affiliateStatus) || affiliateStatus.PENDING,
      commissionPercentages,
    });
  }
  return rows;
};

export const getAllAffiliates = async () => {
  const querySnapshot = await getDocs(collection(db, COLLECTIONS.AFFILIATES));
  const rows = [];
  for (let i = 0; i < querySnapshot.docs.length; i++) {
    const d = querySnapshot.docs[i];

    const tempData = d.data();
    const commissionPercentages = [];
    if (tempData.promocodes) {
      for (let index = 0; index < tempData.promocodes.length; index++) {
        const promocode = tempData.promocodes[index];

        // Get commission
        const pDocRef = doc(db, COLLECTIONS.CREATED_PROMOCODES, promocode);
        const pDocSnap = await getDoc(pDocRef);
        if (pDocSnap.exists) {
          commissionPercentages.push(pDocSnap.data()?.commission_percentage || 'N/A');
        }
      }
    }

    rows.push({
      id: d.id,
      ...tempData,
      createdAt: new Date(d?._document?.createTime?.timestamp?.seconds * 1000).toDateString() || '',
      status: Number(tempData?.affiliateStatus) || affiliateStatus.PENDING,
      commissionPercentages,
    });
  }

  return rows;
};

export const getAffiliateById = async (id, withAffiliatedBookings = false) => {
  let data = {};
  const docRef = doc(db, COLLECTIONS.AFFILIATES, id);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const mainData = docSnap.data();
    data = {
      ...mainData,
      createdAt:
        new Date(docSnap?._document?.createTime?.timestamp?.seconds * 1000).toDateString() || '',
      status: Number(mainData?.affiliateStatus) || affiliateStatus.PENDING,
    };
    if (withAffiliatedBookings) {
      if (mainData.affiliateStatus === affiliateStatus.APPROVED) {
        const bookingsWithAffiliateCode = [];

        if (data.promocodes) {
          for (let index = 0; index < data.promocodes.length; index++) {
            const promocode = data.promocodes[index];

            // Get commission
            const pDocRef = doc(db, COLLECTIONS.CREATED_PROMOCODES, promocode);
            const pDocSnap = await getDoc(pDocRef);
            if (pDocSnap.exists) {
              const pData = pDocSnap.data();

              // TODO[CleanUp]: fetch bookings from rezgo
              const q = query(
                collection(db, COLLECTIONS.BOOKINGS),
                where('promocode', '==', promocode)
              );
              // TODO: fetch commission data from promocode_created collections
              const querySnapshot = await getDocs(q);

              querySnapshot.forEach((d) => {
                const tempData = d.data();
                bookingsWithAffiliateCode.push({
                  promocode,
                  claimer: tempData.email,
                  commission: pData.commision_percentage,
                  excursion: d.id,
                  usedOn:
                    new Date(d?._document?.createTime?.timestamp?.seconds * 1000).toDateString() ||
                    '',
                });
              });
            }
          }
        }

        data.bookingAffliliations = [...bookingsWithAffiliateCode];
      } else {
        data.bookingAffliliations = [];
      }
    }

    return data;
  }
  throw new Error('No Affiliate found with id: ', id);
};

export const changeAffiliateStatus = async (documentId, newStatusValue) => {
  const documentRef = doc(db, COLLECTIONS.AFFILIATES, documentId);
  await updateDoc(documentRef, { affiliateStatus: newStatusValue });
};

export const approveAffiliate = async ({ documentId }) => {
  const documentRef = doc(db, COLLECTIONS.AFFILIATES, documentId);
  const docSnap = await getDoc(documentRef);

  if (docSnap.exists()) {
    const mainData = docSnap.data();
    const { promocodes } = mainData;

    if (promocodes && promocodes?.length > 0) {
      const currentCode = promocodes[0];
      const docRef = doc(db, COLLECTIONS.TO_BE_CREATED_PROMOCODES, currentCode);
      const codeSnap = await getDoc(docRef);
      if (codeSnap.exists()) {
        const toCpyData = codeSnap.data();
        const newDoc = doc(db, COLLECTIONS.CREATED_PROMOCODES, currentCode);
        await setDoc(newDoc, toCpyData);

        const updateData = {
          affiliateStatus: affiliateStatus.APPROVED,
        };

        // if (promocode) {
        //   updateData.promocodes = arrayUnion(promocode);
        // }

        await updateDoc(documentRef, updateData);
        await mailTriggerOnApproval(
          mainData.email,
          mainData.firstName,
          mainData.lastName,
          currentCode
        );
      } else {
        throw new Error('No promocodes details found.');
      }
    } else {
      throw new Error('No promocodes found for this affiliate.');
    }
  } else {
    throw new Error('No affiliate found.');
  }
};

export const getAffiliateCommissonDetailById = async (id) => {
  const data = { commission: 0, promocode: '' };
  const documentRef = doc(db, COLLECTIONS.AFFILIATES, id);
  const docSnap = await getDoc(documentRef);

  if (docSnap.exists()) {
    const mainData = docSnap.data();

    const { promocodes } = mainData;

    if (promocodes && promocodes?.length > 0) {
      const currentCode = promocodes[0];
      const docRef = doc(db, COLLECTIONS.CREATED_PROMOCODES, currentCode);
      const codeSnap = await getDoc(docRef);

      if (codeSnap.exists()) {
        const promocodeData = codeSnap.data();

        data.commission = promocodeData.commission_percentage;
        data.promocode = currentCode;
        return data;
      }
      throw new Error('No promocodes details found.');
    } else {
      throw new Error('No promocodes found for this affiliate.');
    }
  } else {
    throw new Error('No affiliate details found.');
  }
};

export const updateAffiliateCommissonDetailById = async (id, { commission, currentPromoCode }) => {
  const affiliateDocRef = doc(db, COLLECTIONS.AFFILIATES, id);
  const docSnap = await getDoc(affiliateDocRef);

  if (docSnap.exists()) {
    const promocodeDocRef = doc(db, COLLECTIONS.CREATED_PROMOCODES, currentPromoCode);
    const promocodeSnap = await getDoc(promocodeDocRef);
    if (promocodeSnap.exists()) {
      await updateDoc(promocodeDocRef, { commission_percentage: Number(commission) });
    } else {
      throw new Error('No pormocode details found.');
    }
  } else {
    throw new Error('No affiliate details found.');
  }
};

// eslint-disable-next-line no-unused-vars
export const proccessPayments = async (ids) => {
  const responsePayment = await ProcessPaymentUsingBackend(ids);
  return responsePayment;
};
